import { InfoSheet } from '@/shared/components/ui/InfoSheet'

const FORMATIONS = ['5-4-1', '5-3-2', '5-2-3', '4-5-1', '4-4-2', '4-3-3', '3-5-2', '3-4-3']

export function SquadRulesSheet({ onClose }: { onClose: () => void }) {
  return (
    <InfoSheet title="Regras de escalação" onClose={onClose}>
      <InfoSheet.Section>
        <InfoSheet.Lead>
          São 15 jogadores — 11 titulares + 4 reservas — dentro de um orçamento de $100.
          A formação é <b>dinâmica</b>: ela se ajusta sozinha conforme os titulares que você
          escala (o goleiro é sempre 1). Não existe formação fixa, qualquer combinação válida vale.
        </InfoSheet.Lead>
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Limites de titulares</InfoSheet.SectionTitle>
        <InfoSheet.Table>
          <thead>
            <tr><th>Posição</th><th>Mín.</th><th>Máx.</th><th>No elenco</th></tr>
          </thead>
          <tbody>
            <tr><td>Goleiro (GK)</td><td>1</td><td>1</td><td>2</td></tr>
            <tr><td>Defensor (DEF)</td><td>3</td><td>5</td><td>5</td></tr>
            <tr><td>Meio-campo (MID)</td><td>2</td><td>5</td><td>5</td></tr>
            <tr><td>Atacante (FWD)</td><td>1</td><td>3</td><td>3</td></tr>
          </tbody>
        </InfoSheet.Table>
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Formações válidas (8)</InfoSheet.SectionTitle>
        <InfoSheet.Chips>
          {FORMATIONS.map((f) => <InfoSheet.Chip key={f}>{f}</InfoSheet.Chip>)}
        </InfoSheet.Chips>
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Banco e substituições</InfoSheet.SectionTitle>
        <InfoSheet.List>
          <InfoSheet.Item>O banco tem 1 reserva de goleiro + 3 reservas de linha, em ordem de prioridade (Sub 1 → Sub 2 → Sub 3).</InfoSheet.Item>
          <InfoSheet.Item>Se um titular joga <b>0 minutos</b>, o primeiro reserva elegível entra — desde que os mínimos por posição continuem respeitados.</InfoSheet.Item>
          <InfoSheet.Item>O reserva de goleiro só substitui o goleiro titular.</InfoSheet.Item>
          <InfoSheet.Item>Jogadores de seleções eliminadas no banco não entram (contam como se não tivessem jogado).</InfoSheet.Item>
        </InfoSheet.List>
        <InfoSheet.Note>
          <p>
            Os círculos vazios no campo são dinâmicos: mostram o máximo de jogadores ainda
            possível para aquela posição. Escalar um 5º defensor, por exemplo, limita o meio-campo a 4.
          </p>
        </InfoSheet.Note>
      </InfoSheet.Section>
    </InfoSheet>
  )
}
